import appStore from '@/store';

export const dispatchCommentsSidebarShowMentionDetails = (element: HTMLElement) => {
  return appStore.dispatch('commentsSidebarShowMentionDetails', element);
};
